import currentUser from './currentUser'
import {combineReducers} from 'redux';

export const loadFromLocalStorage = () => {
    try {
        const serializeState = localStorage.getItem('currentUser')
        if (serializeState === null) return undefined
        return JSON.parse(serializeState)
    }
    catch(e) {
        console.error(e)
        return undefined
    }
} 

export const saveToLocalStorage = (state) => {
    try {
        const serializeState =  JSON.stringify(state)
         localStorage.setItem('currentUser', serializeState)
        return
    }
    catch(e) {
        console.error(e)
        return undefined
    }
} 



const rootReducer = combineReducers({
    currentUser,
})

export default rootReducer